





















































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import FileOpen from '@/commonComponents/fileOpen/fileOpen.vue';
// import SelectPattern from './selectPattern/selectPattern.vue';
// import SelectLine from './selectLine/selectLine.vue';
import AlertModal from "@/commonComponents/alertModal/alertModal.vue"
import DeletePageModal from "@/commonComponents/alertModal/deletePageModal/deletePageModal.vue"
import SelectSaveStorageModal from "@/commonComponents/alertModal/selectSaveStorageModal/selectSaveStorageModal.vue";

import * as def from '@/definitions'
import { Const } from '@/const'
// TODO document2
import { Document } from '@/model/document2/document'

//ズームバー用のモジュール
import { UndoRedoManager } from '@/utilityModels/undoRedoManager';

import ValueEdit from "@/commonComponents/valueEdit/valueEdit.vue";
import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

// ボタン
import Save from "../topController/resources/save.vue";
import ZoomMinus from "../topController/resources/zoomMinus.vue";
import ZoomPlus from "../topController/resources/zoomPlus.vue";
import ZoomValue from "../topController/resources/zoomValue.vue";
import AutomaticMode from "../topController/resources/automaticMode.vue";
import Automatic from "../topController/resources/automatic.vue";
import RotateSurfaceButton from "../topController/resources/rotateSurfaceButton.vue";
import ArrowDown from "./resources/arrowDown.vue";

import { DebugHelper } from "@/helper/debugHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import RangeSlider from '@/components/VRangeSliderZoom.vue';

@Component({
  components: {
    RangeSlider,
    AlertModal,
    DeletePageModal,
    SelectSaveStorageModal,
    ValueEdit,
    DropdownList,
    Save,
    ZoomMinus,
    ZoomPlus,
    ZoomValue,
    AutomaticMode,
    Automatic,
    RotateSurfaceButton,
    ArrowDown,
  },
})
export default class TopControllerInsertion extends Vue {

    @Prop() private document! : Document;
    @Prop() private maxPage! : number;
    @Prop() private zoomScale! : number;
    @Prop() private isAutoZoom! : boolean;

    private static readonly ZOOM_SCALE_MIN = Const.CANVAS_ZOOM_MIN;
    private static readonly ZOOM_SCALE_MAX = Const.CANVAS_ZOOM_MAX;
    private static readonly ZOOM_SCALE_DELTA = 25;

    private get zoomMin() { return TopControllerInsertion.ZOOM_SCALE_MIN; }
    private get zoomMax() { return TopControllerInsertion.ZOOM_SCALE_MAX; }

    alertModalShown = false;
    deletePageModalShown = false;
    selectStorageModalShown = false;
    upperLimitTitle = "ページ数が上限を超えました";
    upperLimitMessage = "ページ数が上限を超えたため、これ以上追加できません。";

    private get isDebugMode(){
        return DebugHelper.isDebugMode;
    }

    private get isElectron()
    {
        return UserAgentHelper.isElectron();
    }

    // スライダー
    private get zoomScaleSliderValue() { return this.zoomScale; }
    private set zoomScaleSliderValue(zoomScaleSliderValue) { this.onDoCommand("changeZoomScale", { scale :zoomScaleSliderValue, isAutoZoomOff : true }); }

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    // ドキュメント保存
    private onClickSaveDocumentButton()
    {
        this.onDoCommand("saveDocument", null);
    }

    // 回転
    private onRotateSurface()
    {
        this.onDoCommand("rotateDocument", {delta : 90});
    }

    // 塗り足し
    private get maxBleedSize() { return Const.BLEED_SIZE_MAX; }
    private get bleedSize() { return this.$store.getters.userConfig.bleedSize; }
    private setBleedSize(value: number, tag: string)
    {
        this.onDoCommand("changeUserConfig", { propertyName : tag, value : value });
    }

    // ズーム
    private decreaseZoomScale()
    {
        // 今のzoomScaleより小さく適切な値を求める
        var newValue = TopControllerInsertion.ZOOM_SCALE_MAX;
        while(newValue >= TopControllerInsertion.ZOOM_SCALE_MIN)
        {
            if(newValue < this.zoomScale) { break; }
            newValue -= TopControllerInsertion.ZOOM_SCALE_DELTA;
        }
        if(this.zoomScale != newValue && newValue >= TopControllerInsertion.ZOOM_SCALE_MIN)
        {
            this.onDoCommand("changeZoomScale", { scale : newValue, isAutoZoomOff : true });
        }
    }

    private increaseZoomScale()
    {
        // 今のzoomScaleより大きく適切な値を求める
        var newValue = TopControllerInsertion.ZOOM_SCALE_MIN;
        while(newValue <= TopControllerInsertion.ZOOM_SCALE_MAX)
        {
            if(newValue > this.zoomScale) { break; }
            newValue += TopControllerInsertion.ZOOM_SCALE_DELTA;
        }
        if(this.zoomScale != newValue && newValue <= TopControllerInsertion.ZOOM_SCALE_MAX)
        {
            this.onDoCommand("changeZoomScale", { scale : newValue, isAutoZoomOff : true });
        }
    }

    private changeAutoZoom()
    {
        this.onDoCommand("changeAutoZoom", { isAutoZoom : !this.isAutoZoom });
    }

    //ズームバー
    speechBaloon = false;

    //ズームバーの吹き出し
    private get zoomSpeechBalloon(){
        let range = (1000 - this.zoomScale) / 475 + "%";

        let distance = "calc(" + this.zoomScale / 10 + "% - 22.5% - " + range + ")";
        var style = {
            position: "absolute",
            left: distance,
            top: "-70%",
            width: "45%",
            height: "70%",
            display: "flex",
            "align-items": "center",
            "justify-content": "center"
        };
        return style;
    }

    progress = 0;
    startPosition = 0;
    scrollWidth = 0;
    scroll(right: boolean): void{
        let topController = this.$refs["top-controller"];
        this.startPosition = (<HTMLElement>topController).scrollLeft;
        this.progress = 0;
        if((<HTMLElement>topController).clientWidth < 820){ // 目視で調整
            this.scrollWidth = (right ? 1 : -1) * 450; // １度目でコピーが左端に来るように調整
        }else{
            this.scrollWidth = (right ? 1 : -1) * ((<HTMLElement>topController).scrollWidth - (<HTMLElement>topController).offsetWidth);
        }
        requestAnimationFrame(this.scrollMove);
    }

    scrollMove(){
        this.progress++;
        let topController = this.$refs["top-controller"];
        let position = this.startPosition + Math.sign(this.scrollWidth) * this.progress * 20;
        (<HTMLElement>topController).scrollTo(position, 0);

        if(position < this.startPosition + this.scrollWidth && this.scrollWidth > 0
        || position > this.startPosition + this.scrollWidth && this.scrollWidth < 0){
            requestAnimationFrame(this.scrollMove);
        }
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigDarkColor(){
        return this.$store.getters.userConfigColors.darkButtonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }


    //----------insertionトップコントローラーの処理----------//
    // 開始面
    private get offset() { return this.document.insertionData.offset + 1; }
    private get maxOffset()
    {
        var result = 1;
        // ページの貼り付け可能面数
        if(this.document.pageCount > 0)
        {
            var page = this.document.pageList[0];
            result = page.designMaxNumber;
        }
        return result;
    }
    private setOffset(value)
    {
        this.onDoCommand("setOffset", { offset : value - 1 });
    }

    private get maxRow() 
    { 
        // 「１行目を列名にする」がONのときは、1引いたものが最大
        var row = this.document.insertionData.isFirstRowAsColumnName ? 
            this.document.insertionData.getRowDataCount() - 1 :this.document.insertionData.getRowDataCount();
        return row; 
    }

    // 差し込み範囲開始行
    private get startRow() 
    {
        // 「１行目を列名にする」がONのときは、1引いて表示する
        var row = this.document.insertionData.isFirstRowAsColumnName ? 
            this.document.insertionData.startRow : this.document.insertionData.startRow + 1;
        // 0のときは1と表示する
        if(row < 1) row = 1;
        return row; 
    }
    private setStartRow(startRow)
    {
        if(startRow <= this.endRow)
        {
            // 「１行目を列名にする」がONのときは、1足して設定する
            var newRow = this.document.insertionData.isFirstRowAsColumnName ? 
                startRow : startRow - 1;
            this.onDoCommand("setStartRow", { row : newRow });
        }
    }
    // 差し込み範囲終了
    private get endRow() 
    { 
        // 「１行目を列名にする」がONのときは、1引いて表示する
        var row = this.document.insertionData.isFirstRowAsColumnName ? 
            this.document.insertionData.endRow : this.document.insertionData.endRow + 1;
        return row; 
    }
    private setEndRow(endRow)
    {
        if(this.startRow <= endRow)
        {
            // 「１行目を列名にする」がONのときは、1足して設定する
            var newRow = this.document.insertionData.isFirstRowAsColumnName ? 
                endRow : endRow - 1;
            this.onDoCommand("setEndRow", { row : newRow });
        }
    }

    // 枚数
    private get printCount() { return this.document.insertionData.printCount; }
    private setCount(count)
    {
        this.onDoCommand("setPrintCount", { count : count });
    }

    // 流し込み
    private get insertionDirection() { return this.document.insertionData.insertionDirection; }
    private isInsertionDirectionDropdownVisible = false;

    private get insertionDirectionDropdownItems()
    {
        var items = new Array();
            items.push({
            id: 0,
            isSelected: this.insertionDirection == 0,
            label: "横方向"
        });
        items.push({
            id: 1,
            isSelected: this.insertionDirection == 1,
            label: "縦方向"
        });
        return items;
    }

    private setInsertionDirection(direction : number)
    {
        this.isInsertionDirectionDropdownVisible = false;
        this.onDoCommand("setInsertionDirection", { direction : direction });
    }

    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

}
